<body>
  @if (isLoading()) {
    <cert-loader></cert-loader>
  }
  <cert-nav-menu></cert-nav-menu>
  <main class="container-fluid mt-4 px-4" id="main">
    <router-outlet></router-outlet>
  </main>
  <cert-toast-container></cert-toast-container>
  @if (environment && environment.toLowerCase() !== 'prod') {
    <div class="fixed-bottom h6 ms-2" style="width: fit-content">
      <span class="badge bg-warning">{{ environment | uppercase }}</span>
    </div>
  }
</body>
